import { FC, ReactNode } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    children: ReactNode;
    text?: string; // only for storybook
    className?: string;
}

const Heading1: FC<Props> = ({ children, text, className }) => {
    return <h1 className={cn('text-4xl font-bold leading-tight tracking-tight', className)}>{text ?? children}</h1>;
};

export default Heading1;
